import { RSiloBoisDurationSchema_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
/* Importing the json file. */
const Data = require('../json/RSiloBoisDuration.json')

export function fetchSiloBoisDurationSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(Data)
}

/**
 * It fetches the data from the Data object and returns it.
 * @param {string} uuid - string
 * @returns RSiloBoisDurationSchema_Type
 */
export function fetchSiloBoisDuration(uuid: string): RSiloBoisDurationSchema_Type {
  return fetchGeneric<RSiloBoisDurationSchema_Type>(Data, uuid)
}
